import { Stack, StackOwnProps, styled } from '@mui/material';
import {
  LayoutAlignItems,
  LayoutDirection,
  LayoutJustifyContent,
  LayoutMediaQuery,
  LayoutPadding,
} from '@/constants/layoutTypes';

interface LayoutProps {
  id?: string | null;
  direction: LayoutDirection;
  spacing: number;
  align_items: LayoutAlignItems;
  justify_content: LayoutJustifyContent;
  media_query?: LayoutMediaQuery | null;
  padding?: LayoutPadding | null;
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({
  id,
  direction,
  spacing,
  align_items,
  justify_content,
  media_query,
  padding,
  children,
}) => {
  return (
    <StyledStack
      id={id ?? undefined}
      direction={direction}
      spacing={spacing}
      alignItems={align_items}
      justifyContent={justify_content}
      mediaQuery={media_query}
      layoutPadding={padding}
    >
      {children}
    </StyledStack>
  );
};

interface StyledLayoutProps {
  direction: StackOwnProps['direction'];
  spacing: StackOwnProps['spacing'];
  alignItems: LayoutAlignItems;
  justifyContent: LayoutJustifyContent;
  mediaQuery?: LayoutMediaQuery | null;
  layoutPadding?: LayoutPadding | null;
}

const StyledStack = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'mediaQuery' && prop !== 'layoutPadding',
})<StyledLayoutProps>`
  align-items: ${(props) => props.alignItems};
  justify-content: ${(props) => props.justifyContent};
  text-wrap: pretty;
  padding: ${(props) => {
    switch (props.layoutPadding) {
      case LayoutPadding.SMALL:
        return '16px';
      case LayoutPadding.LARGE:
        return 'min(46px, 4vw)';
      default:
        return '0';
    }
  }};

  ${({ mediaQuery }) => {
    if (mediaQuery === LayoutMediaQuery.HIDE_ON_SMALL_SCREENS) {
      return '@media (max-width: 767px) { display: none; }';
    } else if (mediaQuery === LayoutMediaQuery.HIDE_ON_LARGE_SCREENS) {
      return '@media (min-width: 768px) { display: none; }';
    } else return '';
  }}
`;
